import { useRegisterSW } from 'virtual:pwa-register/react'
import { useT } from '../lib/i18n'

/**
 * Register the service worker and offer the update (frontend-stack.md §PWA).
 *
 * It sits *below the header*, not over the composer. It used to be pinned to the bottom of the
 * viewport, where it covered the message field and, on the phone, swallowed taps meant for the
 * composer — the first capture pass of this redesign could not click "Attach" until the banner was
 * dismissed. A banner that blocks the input is worse than no banner.
 */
export function ReloadPrompt() {
  const t = useT()
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.error('[pwa] sw registration failed', error)
    },
  })

  if (!offlineReady && !needRefresh) return null

  const close = () => {
    setOfflineReady(false)
    setNeedRefresh(false)
  }

  return (
    <div
      role="status"
      className="panel-enter fixed end-3 top-[calc(var(--sat)+var(--header-h)+8px)] z-40 flex max-w-[calc(100%-24px)] items-center gap-2 rounded-panel border-s-2 border-accent bg-surface/95 py-1.5 ps-3 pe-1.5 text-ink shadow-lift backdrop-blur-sm ring-1 ring-line-strong"
    >
      <span className="text-meta">
        {needRefresh ? t('pwa.newVersion') : t('pwa.offlineReady')}
      </span>
      {needRefresh && (
        <button
          type="button"
          onClick={() => void updateServiceWorker(true)}
          className="min-h-11 rounded-full px-3 text-meta font-semibold text-accent transition-colors duration-quick hover:bg-surface2"
        >
          {t('pwa.reload')}
        </button>
      )}
      <button
        type="button"
        onClick={close}
        className="min-h-11 rounded-full px-3 text-meta text-muted transition-colors duration-quick hover:bg-surface2 hover:text-ink"
      >
        {t('pwa.dismiss')}
      </button>
    </div>
  )
}
